/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CopropertyDto } from './CopropertyDto';
import {
    CopropertyDtoFromJSON,
    CopropertyDtoFromJSONTyped,
    CopropertyDtoToJSON,
    CopropertyDtoToJSONTyped,
} from './CopropertyDto';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';

/**
 * 
 * @export
 * @interface GetCopropertyByContractResponse
 */
export interface GetCopropertyByContractResponse {
    /**
     * 
     * @type {CopropertyDto}
     * @memberof GetCopropertyByContractResponse
     */
    coproperty?: CopropertyDto;
    /**
     * COPRO_MRI session answers; absent when the survey was never started
     * @type {Array<QuestionAnswerDto>}
     * @memberof GetCopropertyByContractResponse
     */
    surveyAnswers?: Array<QuestionAnswerDto> | null;
}

/**
 * Check if a given object implements the GetCopropertyByContractResponse interface.
 */
export function instanceOfGetCopropertyByContractResponse(value: object): value is GetCopropertyByContractResponse {
    return true;
}

export function GetCopropertyByContractResponseFromJSON(json: any): GetCopropertyByContractResponse {
    return GetCopropertyByContractResponseFromJSONTyped(json, false);
}

export function GetCopropertyByContractResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCopropertyByContractResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'coproperty': json['coproperty'] == null ? undefined : CopropertyDtoFromJSON(json['coproperty']),
        'surveyAnswers': json['surveyAnswers'] == null ? undefined : ((json['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
    };
}

export function GetCopropertyByContractResponseToJSON(json: any): GetCopropertyByContractResponse {
    return GetCopropertyByContractResponseToJSONTyped(json, false);
}

export function GetCopropertyByContractResponseToJSONTyped(value?: GetCopropertyByContractResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coproperty': CopropertyDtoToJSON(value['coproperty']),
        'surveyAnswers': value['surveyAnswers'] == null ? undefined : ((value['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
    };
}

